<template>
	<ms-popup
		:active.sync="active"
		@close="closePopup"
		:width="400"
		:height="config.height || 350"
		:autoFocus="false"
		:forceRender="true"
		:posZ="1200"
		class="ms-message-toast"
	>
		<template slot="content">
			<components :is="config.template" v-if="config.template"></components>
			<div
				class="flex-box align-center w-full h-full ms-pdl-16px ms-pdr-16px ms-pdb-20px"
				v-else
			>
				<div class="img-confirm flex flex-1 items-center ms-mgt-44px">
					<img :src="imgLink" />
				</div>
				<div class="msg text-center mt-2" v-html="config.message"></div>
				<div class="btn-msg ms-mgt-20px" v-if="config.button">
					<ms-button
						:title="config.button.title"
						@click="btnAction"
						cssClass="btn-toast"
					></ms-button>
				</div>
			</div>
		</template>
	</ms-popup>
</template>
<script>
export default {
	name: 'msMessagesToast',
	data() {
		return {
			active: false,
			config: {
				type: this.$ms.enum.msgToastType.Success,
				message: null,
				icon: null,
				template: null,
				time: null,
				button: null,
				height: 350, // Default height
			},
		};
	},
	computed: {
		imgLink() {
			const me = this;
			if (me.config.type == me.$ms.enum.msgToastType.Success) {
				return require('@/assets/images/icons/success-bot.png');
			} else if (me.config.type == me.$ms.enum.msgToastType.Error) {
				return require('@/assets/images/icons/Mascot_7.png');
			}
			return null;
		},
	},
	methods: {
		showPopup(config) {
			const me = this;
			me.config = config;
			if (me.config.time) {
				setTimeout(() => {
					me.closePopup();
				}, me.config.time);
			}
			me.$nextTick(() => {
				me.active = true;
			});
		},
		btnAction() {
			const me = this;
			if (me.config.button && typeof me.config.button.action == 'function') {
				me.config.button.action();
			}
			me.active = false;
		},
		closePopup() {
			const me = this;
			me.active = false;
		},
	},
};
</script>
<style lang="scss" scoped>
.ms-message-toast {
	z-index: 1001;
}
/deep/.btn-toast{
	width: 80px;
}
</style>
